// fetch("https://countries-api.pages.dev/phone-alpha-3.json")
//   .then((x) => x.json())
// .then(list => list.reduce((prev, curr) => ({...prev, [curr.prefix]: [...(prev[curr.prefix] || []), curr]}), {}))
// .then(obj => Object.entries(obj).map(([key, value]) => ({prefix: key, name: value.map(x => x.name).join(', '), cca3: value.map(x => x.cca3).join(', ')})))
// .then(list => list.map(x => ({prefix: parseInt(x.prefix.substring(1)), name: x.name, cca3: x.cca3})))
// .then(list => list.sort((a, b) => a.prefix < b.prefix ? -1 : a.prefix > b.prefix ? 1 : 0))
// .then(list => list.map(x => ({...x,id: x.prefix.toString(), prefix: `+${x.prefix}`})))

export interface PhoneCountryCode {
  // should be a number but everywhere in cymonz isd is a string
  id: string;
  cca3: string;
  prefix: string;
  name: string;
}

export const phoneCountryCodes: PhoneCountryCode[] = [
  {
    prefix: "+1",
    name: "Canada, Dominican Republic, Puerto Rico, United States",
    cca3: "CAN, DOM, PRI, USA",
    id: "1",
  },
  {
    prefix: "+7",
    name: "Kazakhstan, Russia",
    cca3: "KAZ, RUS",
    id: "7",
  },
  {
    prefix: "+20",
    name: "Egypt",
    cca3: "EGY",
    id: "20",
  },
  {
    prefix: "+27",
    name: "South Africa",
    cca3: "ZAF",
    id: "27",
  },
  {
    prefix: "+30",
    name: "Greece",
    cca3: "GRC",
    id: "30",
  },
  {
    prefix: "+31",
    name: "Netherlands",
    cca3: "NLD",
    id: "31",
  },
  {
    prefix: "+32",
    name: "Belgium",
    cca3: "BEL",
    id: "32",
  },
  {
    prefix: "+33",
    name: "France",
    cca3: "FRA",
    id: "33",
  },
  {
    prefix: "+34",
    name: "Spain",
    cca3: "ESP",
    id: "34",
  },
  {
    prefix: "+36",
    name: "Hungary",
    cca3: "HUN",
    id: "36",
  },
  {
    prefix: "+39",
    name: "Italy",
    cca3: "ITA",
    id: "39",
  },
  {
    prefix: "+40",
    name: "Romania",
    cca3: "ROU",
    id: "40",
  },
  {
    prefix: "+41",
    name: "Switzerland",
    cca3: "CHE",
    id: "41",
  },
  {
    prefix: "+43",
    name: "Austria",
    cca3: "AUT",
    id: "43",
  },
  {
    prefix: "+44",
    name: "Guernsey, Isle of Man, Jersey, United Kingdom",
    cca3: "GGY, IMN, JEY, GBR",
    id: "44",
  },
  {
    prefix: "+45",
    name: "Denmark",
    cca3: "DNK",
    id: "45",
  },
  {
    prefix: "+46",
    name: "Sweden",
    cca3: "SWE",
    id: "46",
  },
  {
    prefix: "+47",
    name: "Bouvet Island, Norway",
    cca3: "BVT, NOR",
    id: "47",
  },
  {
    prefix: "+48",
    name: "Poland",
    cca3: "POL",
    id: "48",
  },
  {
    prefix: "+49",
    name: "Germany",
    cca3: "DEU",
    id: "49",
  },
  {
    prefix: "+51",
    name: "Peru",
    cca3: "PER",
    id: "51",
  },
  {
    prefix: "+52",
    name: "Mexico",
    cca3: "MEX",
    id: "52",
  },
  {
    prefix: "+53",
    name: "Cuba",
    cca3: "CUB",
    id: "53",
  },
  {
    prefix: "+54",
    name: "Argentina",
    cca3: "ARG",
    id: "54",
  },
  {
    prefix: "+55",
    name: "Brazil",
    cca3: "BRA",
    id: "55",
  },
  {
    prefix: "+56",
    name: "Chile",
    cca3: "CHL",
    id: "56",
  },
  {
    prefix: "+57",
    name: "Colombia",
    cca3: "COL",
    id: "57",
  },
  {
    prefix: "+58",
    name: "Venezuela",
    cca3: "VEN",
    id: "58",
  },
  {
    prefix: "+60",
    name: "Malaysia",
    cca3: "MYS",
    id: "60",
  },
  {
    prefix: "+61",
    name: "Australia, Christmas Island, Cocos (Keeling) Islands",
    cca3: "AUS, CXR, CCK",
    id: "61",
  },
  {
    prefix: "+62",
    name: "Indonesia",
    cca3: "IDN",
    id: "62",
  },
  {
    prefix: "+63",
    name: "Philippines",
    cca3: "PHL",
    id: "63",
  },
  {
    prefix: "+64",
    name: "New Zealand, Pitcairn Islands",
    cca3: "NZL, PCN",
    id: "64",
  },
  {
    prefix: "+65",
    name: "Singapore",
    cca3: "SGP",
    id: "65",
  },
  {
    prefix: "+66",
    name: "Thailand",
    cca3: "THA",
    id: "66",
  },
  {
    prefix: "+81",
    name: "Japan",
    cca3: "JPN",
    id: "81",
  },
  {
    prefix: "+82",
    name: "South Korea",
    cca3: "KOR",
    id: "82",
  },
  {
    prefix: "+84",
    name: "Vietnam",
    cca3: "VNM",
    id: "84",
  },
  {
    prefix: "+86",
    name: "China",
    cca3: "CHN",
    id: "86",
  },
  {
    prefix: "+90",
    name: "Turkey",
    cca3: "TUR",
    id: "90",
  },
  {
    prefix: "+91",
    name: "India",
    cca3: "IND",
    id: "91",
  },
  {
    prefix: "+92",
    name: "Pakistan",
    cca3: "PAK",
    id: "92",
  },
  {
    prefix: "+93",
    name: "Afghanistan",
    cca3: "AFG",
    id: "93",
  },
  {
    prefix: "+94",
    name: "Sri Lanka",
    cca3: "LKA",
    id: "94",
  },
  {
    prefix: "+95",
    name: "Myanmar",
    cca3: "MMR",
    id: "95",
  },
  {
    prefix: "+98",
    name: "Iran",
    cca3: "IRN",
    id: "98",
  },
  {
    prefix: "+211",
    name: "South Sudan",
    cca3: "SSD",
    id: "211",
  },
  {
    prefix: "+212",
    name: "Morocco, Western Sahara",
    cca3: "MAR, ESH",
    id: "212",
  },
  {
    prefix: "+213",
    name: "Algeria",
    cca3: "DZA",
    id: "213",
  },
  {
    prefix: "+216",
    name: "Tunisia",
    cca3: "TUN",
    id: "216",
  },
  {
    prefix: "+218",
    name: "Libya",
    cca3: "LBY",
    id: "218",
  },
  {
    prefix: "+220",
    name: "Gambia",
    cca3: "GMB",
    id: "220",
  },
  {
    prefix: "+221",
    name: "Senegal",
    cca3: "SEN",
    id: "221",
  },
  {
    prefix: "+222",
    name: "Mauritania",
    cca3: "MRT",
    id: "222",
  },
  {
    prefix: "+223",
    name: "Mali",
    cca3: "MLI",
    id: "223",
  },
  {
    prefix: "+224",
    name: "Guinea",
    cca3: "GIN",
    id: "224",
  },
  {
    prefix: "+225",
    name: "Ivory Coast",
    cca3: "CIV",
    id: "225",
  },
  {
    prefix: "+226",
    name: "Burkina Faso",
    cca3: "BFA",
    id: "226",
  },
  {
    prefix: "+227",
    name: "Niger",
    cca3: "NER",
    id: "227",
  },
  {
    prefix: "+228",
    name: "Togo",
    cca3: "TGO",
    id: "228",
  },
  {
    prefix: "+229",
    name: "Benin",
    cca3: "BEN",
    id: "229",
  },
  {
    prefix: "+230",
    name: "Mauritius",
    cca3: "MUS",
    id: "230",
  },
  {
    prefix: "+231",
    name: "Liberia",
    cca3: "LBR",
    id: "231",
  },
  {
    prefix: "+232",
    name: "Sierra Leone",
    cca3: "SLE",
    id: "232",
  },
  {
    prefix: "+233",
    name: "Ghana",
    cca3: "GHA",
    id: "233",
  },
  {
    prefix: "+234",
    name: "Nigeria",
    cca3: "NGA",
    id: "234",
  },
  {
    prefix: "+235",
    name: "Chad",
    cca3: "TCD",
    id: "235",
  },
  {
    prefix: "+236",
    name: "Central African Republic",
    cca3: "CAF",
    id: "236",
  },
  {
    prefix: "+237",
    name: "Cameroon",
    cca3: "CMR",
    id: "237",
  },
  {
    prefix: "+238",
    name: "Cape Verde",
    cca3: "CPV",
    id: "238",
  },
  {
    prefix: "+239",
    name: "São Tomé and Príncipe",
    cca3: "STP",
    id: "239",
  },
  {
    prefix: "+240",
    name: "Equatorial Guinea",
    cca3: "GNQ",
    id: "240",
  },
  {
    prefix: "+241",
    name: "Gabon",
    cca3: "GAB",
    id: "241",
  },
  {
    prefix: "+242",
    name: "Republic of the Congo",
    cca3: "COG",
    id: "242",
  },
  {
    prefix: "+243",
    name: "DR Congo",
    cca3: "COD",
    id: "243",
  },
  {
    prefix: "+244",
    name: "Angola",
    cca3: "AGO",
    id: "244",
  },
  {
    prefix: "+245",
    name: "Guinea-Bissau",
    cca3: "GNB",
    id: "245",
  },
  {
    prefix: "+246",
    name: "British Indian Ocean Territory",
    cca3: "IOT",
    id: "246",
  },
  {
    prefix: "+248",
    name: "Seychelles",
    cca3: "SYC",
    id: "248",
  },
  {
    prefix: "+249",
    name: "Sudan",
    cca3: "SDN",
    id: "249",
  },
  {
    prefix: "+250",
    name: "Rwanda",
    cca3: "RWA",
    id: "250",
  },
  {
    prefix: "+251",
    name: "Ethiopia",
    cca3: "ETH",
    id: "251",
  },
  {
    prefix: "+252",
    name: "Somalia",
    cca3: "SOM",
    id: "252",
  },
  {
    prefix: "+253",
    name: "Djibouti",
    cca3: "DJI",
    id: "253",
  },
  {
    prefix: "+254",
    name: "Kenya",
    cca3: "KEN",
    id: "254",
  },
  {
    prefix: "+255",
    name: "Tanzania",
    cca3: "TZA",
    id: "255",
  },
  {
    prefix: "+256",
    name: "Uganda",
    cca3: "UGA",
    id: "256",
  },
  {
    prefix: "+257",
    name: "Burundi",
    cca3: "BDI",
    id: "257",
  },
  {
    prefix: "+258",
    name: "Mozambique",
    cca3: "MOZ",
    id: "258",
  },
  {
    prefix: "+260",
    name: "Zambia",
    cca3: "ZMB",
    id: "260",
  },
  {
    prefix: "+261",
    name: "Madagascar",
    cca3: "MDG",
    id: "261",
  },
  {
    prefix: "+262",
    name: "French Southern and Antarctic Lands, Mayotte, Réunion",
    cca3: "ATF, MYT, REU",
    id: "262",
  },
  {
    prefix: "+263",
    name: "Zimbabwe",
    cca3: "ZWE",
    id: "263",
  },
  {
    prefix: "+264",
    name: "Namibia",
    cca3: "NAM",
    id: "264",
  },
  {
    prefix: "+265",
    name: "Malawi",
    cca3: "MWI",
    id: "265",
  },
  {
    prefix: "+266",
    name: "Lesotho",
    cca3: "LSO",
    id: "266",
  },
  {
    prefix: "+267",
    name: "Botswana",
    cca3: "BWA",
    id: "267",
  },
  {
    prefix: "+268",
    name: "Eswatini, United States Minor Outlying Islands",
    cca3: "SWZ, UMI",
    id: "268",
  },
  {
    prefix: "+269",
    name: "Comoros",
    cca3: "COM",
    id: "269",
  },
  {
    prefix: "+290",
    name: "Saint Helena, Ascension and Tristan da Cunha",
    cca3: "SHN",
    id: "290",
  },
  {
    prefix: "+291",
    name: "Eritrea",
    cca3: "ERI",
    id: "291",
  },
  {
    prefix: "+297",
    name: "Aruba",
    cca3: "ABW",
    id: "297",
  },
  {
    prefix: "+298",
    name: "Faroe Islands",
    cca3: "FRO",
    id: "298",
  },
  {
    prefix: "+299",
    name: "Greenland",
    cca3: "GRL",
    id: "299",
  },
  {
    prefix: "+350",
    name: "Gibraltar",
    cca3: "GIB",
    id: "350",
  },
  {
    prefix: "+351",
    name: "Portugal",
    cca3: "PRT",
    id: "351",
  },
  {
    prefix: "+352",
    name: "Luxembourg",
    cca3: "LUX",
    id: "352",
  },
  {
    prefix: "+353",
    name: "Ireland",
    cca3: "IRL",
    id: "353",
  },
  {
    prefix: "+354",
    name: "Iceland",
    cca3: "ISL",
    id: "354",
  },
  {
    prefix: "+355",
    name: "Albania",
    cca3: "ALB",
    id: "355",
  },
  {
    prefix: "+356",
    name: "Malta",
    cca3: "MLT",
    id: "356",
  },
  {
    prefix: "+357",
    name: "Cyprus",
    cca3: "CYP",
    id: "357",
  },
  {
    prefix: "+358",
    name: "Finland",
    cca3: "FIN",
    id: "358",
  },
  {
    prefix: "+359",
    name: "Bulgaria",
    cca3: "BGR",
    id: "359",
  },
  {
    prefix: "+370",
    name: "Lithuania",
    cca3: "LTU",
    id: "370",
  },
  {
    prefix: "+371",
    name: "Latvia",
    cca3: "LVA",
    id: "371",
  },
  {
    prefix: "+372",
    name: "Estonia",
    cca3: "EST",
    id: "372",
  },
  {
    prefix: "+373",
    name: "Moldova",
    cca3: "MDA",
    id: "373",
  },
  {
    prefix: "+374",
    name: "Armenia",
    cca3: "ARM",
    id: "374",
  },
  {
    prefix: "+375",
    name: "Belarus",
    cca3: "BLR",
    id: "375",
  },
  {
    prefix: "+376",
    name: "Andorra",
    cca3: "AND",
    id: "376",
  },
  {
    prefix: "+377",
    name: "Monaco",
    cca3: "MCO",
    id: "377",
  },
  {
    prefix: "+378",
    name: "San Marino",
    cca3: "SMR",
    id: "378",
  },
  {
    prefix: "+379",
    name: "Vatican City",
    cca3: "VAT",
    id: "379",
  },
  {
    prefix: "+380",
    name: "Ukraine",
    cca3: "UKR",
    id: "380",
  },
  {
    prefix: "+381",
    name: "Serbia",
    cca3: "SRB",
    id: "381",
  },
  {
    prefix: "+382",
    name: "Montenegro",
    cca3: "MNE",
    id: "382",
  },
  {
    prefix: "+383",
    name: "Kosovo",
    cca3: "UNK",
    id: "383",
  },
  {
    prefix: "+385",
    name: "Croatia",
    cca3: "HRV",
    id: "385",
  },
  {
    prefix: "+386",
    name: "Slovenia",
    cca3: "SVN",
    id: "386",
  },
  {
    prefix: "+387",
    name: "Bosnia and Herzegovina",
    cca3: "BIH",
    id: "387",
  },
  {
    prefix: "+389",
    name: "North Macedonia",
    cca3: "MKD",
    id: "389",
  },
  {
    prefix: "+420",
    name: "Czechia",
    cca3: "CZE",
    id: "420",
  },
  {
    prefix: "+421",
    name: "Slovakia",
    cca3: "SVK",
    id: "421",
  },
  {
    prefix: "+423",
    name: "Liechtenstein",
    cca3: "LIE",
    id: "423",
  },
  {
    prefix: "+500",
    name: "Falkland Islands, South Georgia",
    cca3: "FLK, SGS",
    id: "500",
  },
  {
    prefix: "+501",
    name: "Belize",
    cca3: "BLZ",
    id: "501",
  },
  {
    prefix: "+502",
    name: "Guatemala",
    cca3: "GTM",
    id: "502",
  },
  {
    prefix: "+503",
    name: "El Salvador",
    cca3: "SLV",
    id: "503",
  },
  {
    prefix: "+504",
    name: "Honduras",
    cca3: "HND",
    id: "504",
  },
  {
    prefix: "+505",
    name: "Nicaragua",
    cca3: "NIC",
    id: "505",
  },
  {
    prefix: "+506",
    name: "Costa Rica",
    cca3: "CRI",
    id: "506",
  },
  {
    prefix: "+507",
    name: "Panama",
    cca3: "PAN",
    id: "507",
  },
  {
    prefix: "+508",
    name: "Saint Pierre and Miquelon",
    cca3: "SPM",
    id: "508",
  },
  {
    prefix: "+509",
    name: "Haiti",
    cca3: "HTI",
    id: "509",
  },
  {
    prefix: "+590",
    name: "Guadeloupe, Saint Barthélemy, Saint Martin",
    cca3: "GLP, BLM, MAF",
    id: "590",
  },
  {
    prefix: "+591",
    name: "Bolivia",
    cca3: "BOL",
    id: "591",
  },
  {
    prefix: "+592",
    name: "Guyana",
    cca3: "GUY",
    id: "592",
  },
  {
    prefix: "+593",
    name: "Ecuador",
    cca3: "ECU",
    id: "593",
  },
  {
    prefix: "+594",
    name: "French Guiana",
    cca3: "GUF",
    id: "594",
  },
  {
    prefix: "+595",
    name: "Paraguay",
    cca3: "PRY",
    id: "595",
  },
  {
    prefix: "+596",
    name: "Martinique",
    cca3: "MTQ",
    id: "596",
  },
  {
    prefix: "+597",
    name: "Suriname",
    cca3: "SUR",
    id: "597",
  },
  {
    prefix: "+598",
    name: "Uruguay",
    cca3: "URY",
    id: "598",
  },
  {
    prefix: "+599",
    name: "Caribbean Netherlands, Curaçao",
    cca3: "BES, CUW",
    id: "599",
  },
  {
    prefix: "+670",
    name: "Timor-Leste",
    cca3: "TLS",
    id: "670",
  },
  {
    prefix: "+672",
    name: "Norfolk Island",
    cca3: "NFK",
    id: "672",
  },
  {
    prefix: "+673",
    name: "Brunei",
    cca3: "BRN",
    id: "673",
  },
  {
    prefix: "+674",
    name: "Nauru",
    cca3: "NRU",
    id: "674",
  },
  {
    prefix: "+675",
    name: "Papua New Guinea",
    cca3: "PNG",
    id: "675",
  },
  {
    prefix: "+676",
    name: "Tonga",
    cca3: "TON",
    id: "676",
  },
  {
    prefix: "+677",
    name: "Solomon Islands",
    cca3: "SLB",
    id: "677",
  },
  {
    prefix: "+678",
    name: "Vanuatu",
    cca3: "VUT",
    id: "678",
  },
  {
    prefix: "+679",
    name: "Fiji",
    cca3: "FJI",
    id: "679",
  },
  {
    prefix: "+680",
    name: "Palau",
    cca3: "PLW",
    id: "680",
  },
  {
    prefix: "+681",
    name: "Wallis and Futuna",
    cca3: "WLF",
    id: "681",
  },
  {
    prefix: "+682",
    name: "Cook Islands",
    cca3: "COK",
    id: "682",
  },
  {
    prefix: "+683",
    name: "Niue",
    cca3: "NIU",
    id: "683",
  },
  {
    prefix: "+685",
    name: "Samoa",
    cca3: "WSM",
    id: "685",
  },
  {
    prefix: "+686",
    name: "Kiribati",
    cca3: "KIR",
    id: "686",
  },
  {
    prefix: "+687",
    name: "New Caledonia",
    cca3: "NCL",
    id: "687",
  },
  {
    prefix: "+688",
    name: "Tuvalu",
    cca3: "TUV",
    id: "688",
  },
  {
    prefix: "+689",
    name: "French Polynesia",
    cca3: "PYF",
    id: "689",
  },
  {
    prefix: "+690",
    name: "Tokelau",
    cca3: "TKL",
    id: "690",
  },
  {
    prefix: "+691",
    name: "Micronesia",
    cca3: "FSM",
    id: "691",
  },
  {
    prefix: "+692",
    name: "Marshall Islands",
    cca3: "MHL",
    id: "692",
  },
  {
    prefix: "+850",
    name: "North Korea",
    cca3: "PRK",
    id: "850",
  },
  {
    prefix: "+852",
    name: "Hong Kong",
    cca3: "HKG",
    id: "852",
  },
  {
    prefix: "+853",
    name: "Macau",
    cca3: "MAC",
    id: "853",
  },
  {
    prefix: "+855",
    name: "Cambodia",
    cca3: "KHM",
    id: "855",
  },
  {
    prefix: "+856",
    name: "Laos",
    cca3: "LAO",
    id: "856",
  },
  {
    prefix: "+880",
    name: "Bangladesh",
    cca3: "BGD",
    id: "880",
  },
  {
    prefix: "+886",
    name: "Taiwan",
    cca3: "TWN",
    id: "886",
  },
  {
    prefix: "+960",
    name: "Maldives",
    cca3: "MDV",
    id: "960",
  },
  {
    prefix: "+961",
    name: "Lebanon",
    cca3: "LBN",
    id: "961",
  },
  {
    prefix: "+962",
    name: "Jordan",
    cca3: "JOR",
    id: "962",
  },
  {
    prefix: "+963",
    name: "Syria",
    cca3: "SYR",
    id: "963",
  },
  {
    prefix: "+964",
    name: "Iraq",
    cca3: "IRQ",
    id: "964",
  },
  {
    prefix: "+965",
    name: "Kuwait",
    cca3: "KWT",
    id: "965",
  },
  {
    prefix: "+966",
    name: "Saudi Arabia",
    cca3: "SAU",
    id: "966",
  },
  {
    prefix: "+967",
    name: "Yemen",
    cca3: "YEM",
    id: "967",
  },
  {
    prefix: "+968",
    name: "Oman",
    cca3: "OMN",
    id: "968",
  },
  {
    prefix: "+970",
    name: "Palestine",
    cca3: "PSE",
    id: "970",
  },
  {
    prefix: "+971",
    name: "United Arab Emirates",
    cca3: "ARE",
    id: "971",
  },
  {
    prefix: "+972",
    name: "Israel",
    cca3: "ISR",
    id: "972",
  },
  {
    prefix: "+973",
    name: "Bahrain",
    cca3: "BHR",
    id: "973",
  },
  {
    prefix: "+974",
    name: "Qatar",
    cca3: "QAT",
    id: "974",
  },
  {
    prefix: "+975",
    name: "Bhutan",
    cca3: "BTN",
    id: "975",
  },
  {
    prefix: "+976",
    name: "Mongolia",
    cca3: "MNG",
    id: "976",
  },
  {
    prefix: "+977",
    name: "Nepal",
    cca3: "NPL",
    id: "977",
  },
  {
    prefix: "+992",
    name: "Tajikistan",
    cca3: "TJK",
    id: "992",
  },
  {
    prefix: "+993",
    name: "Turkmenistan",
    cca3: "TKM",
    id: "993",
  },
  {
    prefix: "+994",
    name: "Azerbaijan",
    cca3: "AZE",
    id: "994",
  },
  {
    prefix: "+995",
    name: "Georgia",
    cca3: "GEO",
    id: "995",
  },
  {
    prefix: "+996",
    name: "Kyrgyzstan",
    cca3: "KGZ",
    id: "996",
  },
  {
    prefix: "+998",
    name: "Uzbekistan",
    cca3: "UZB",
    id: "998",
  },
  {
    prefix: "+1242",
    name: "Bahamas",
    cca3: "BHS",
    id: "1242",
  },
  {
    prefix: "+1246",
    name: "Barbados",
    cca3: "BRB",
    id: "1246",
  },
  {
    prefix: "+1264",
    name: "Anguilla",
    cca3: "AIA",
    id: "1264",
  },
  {
    prefix: "+1268",
    name: "Antigua and Barbuda",
    cca3: "ATG",
    id: "1268",
  },
  {
    prefix: "+1284",
    name: "British Virgin Islands",
    cca3: "VGB",
    id: "1284",
  },
  {
    prefix: "+1340",
    name: "United States Virgin Islands",
    cca3: "VIR",
    id: "1340",
  },
  {
    prefix: "+1345",
    name: "Cayman Islands",
    cca3: "CYM",
    id: "1345",
  },
  {
    prefix: "+1441",
    name: "Bermuda",
    cca3: "BMU",
    id: "1441",
  },
  {
    prefix: "+1473",
    name: "Grenada",
    cca3: "GRD",
    id: "1473",
  },
  {
    prefix: "+1649",
    name: "Turks and Caicos Islands",
    cca3: "TCA",
    id: "1649",
  },
  {
    prefix: "+1664",
    name: "Montserrat",
    cca3: "MSR",
    id: "1664",
  },
  {
    prefix: "+1670",
    name: "Northern Mariana Islands",
    cca3: "MNP",
    id: "1670",
  },
  {
    prefix: "+1671",
    name: "Guam",
    cca3: "GUM",
    id: "1671",
  },
  {
    prefix: "+1684",
    name: "American Samoa",
    cca3: "ASM",
    id: "1684",
  },
  {
    prefix: "+1721",
    name: "Sint Maarten",
    cca3: "SXM",
    id: "1721",
  },
  {
    prefix: "+1758",
    name: "Saint Lucia",
    cca3: "LCA",
    id: "1758",
  },
  {
    prefix: "+1767",
    name: "Dominica",
    cca3: "DMA",
    id: "1767",
  },
  {
    prefix: "+1784",
    name: "Saint Vincent and the Grenadines",
    cca3: "VCT",
    id: "1784",
  },
  {
    prefix: "+1868",
    name: "Trinidad and Tobago",
    cca3: "TTO",
    id: "1868",
  },
  {
    prefix: "+1869",
    name: "Saint Kitts and Nevis",
    cca3: "KNA",
    id: "1869",
  },
  {
    prefix: "+1876",
    name: "Jamaica",
    cca3: "JAM",
    id: "1876",
  },
  {
    prefix: "+4779",
    name: "Svalbard and Jan Mayen",
    cca3: "SJM",
    id: "4779",
  },
  {
    prefix: "+35818",
    name: "Åland Islands",
    cca3: "ALA",
    id: "35818",
  },
];
